/*
 * @Author: 罗川平 2150673512@qq.com
 * @Date: 2025-06-20 15:19:05
 * @LastEditors: 罗川平 2150673512@qq.com
 * @LastEditTime: 2025-06-23 11:23:37
 * @FilePath: \low_code\src\main.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import vjdesign from 'vjdesign'
import 'vjdesign/dist/vjdesign.css'
 import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import * as L from 'leaflet'
import vjform from 'vjform'
import 'leaflet.pm'
import 'leaflet.pm/dist/leaflet.pm.css'
import 'leaflet/dist/leaflet.css'
import test from './components/test.vue'
import mytable from './components/mytable.vue'
import watch from './components/Watch.vue'
import set from './components/set.vue'
import design from 'jpresent-transform-design'
import expression from 'jpresent-transform-expression'
import axios from 'axios';
Vue.prototype.$axios = axios
Vue.prototype.$url = 'https://www.moodsci.com/SWDataservice/interface/v1/api'
Vue.component(test.name, test)
Vue.component(mytable.name, mytable)
Vue.component(watch.name, watch)
Vue.component(set.name, set)
vjform.use(design)
vjform.use(expression)
Vue.use(vjdesign)
Vue.config.productionTip = false
Vue.use(ElementUI);
Vue.use(vjform)
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
